<template>
  <router-link
    :to="'/customer/notification/' + item.id"
    class="notification-item"
  >
    <div class="tile is-ancestor">
      <div class="tile is-parent is-2 column-status">
        <div
          :class="item.readStatus ? '' : 'unread'"
          class="tile is-child is-3 notification-status"
        />
        <div class="tile is-child is-9 notification-image">
          <div class="img-resize img-resize--small">
            <img
              :src="image"
              alt="..."
              class="img-thumbnail"
            />
          </div>
        </div>
      </div>
      <div class="tile is-parent is-8 notification-content">
        <div v-if="item.category === 1" class="tile is-child">
          <div :class="item.readStatus ? '' : 'bold-text'" class="name_shop tile">
            <div class="tile">
              {{ title }}
            </div>
          </div>
          <div :class="item.readStatus ? '' : 'bold-text'" class="content mt-10">
            <span>{{ `注文内容
                ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝
                ■注文ID：	${item.orderId}	` }}</span>
          </div>
        </div>
        <div v-else-if="item.category === 2" class="tile is-child">
          <div  :class="item.readStatus ? '' : 'bold-text'" class="name_shop tile">
            <div class="tile" >
              {{ title }}
            </div>
          </div>
          <div :class="item.readStatus ? '' : 'bold-text'" class="mt-10">
            <div class="comment-title" >
              {{ item.notificationType === 1 ? content.comment : content.title }}
            </div>
            <div class="comment-reviewed mt-5">
              <RatingIcon :rating="item.notificationType === 1 ? content.rating === 5 : content.rating === 0"/>
            </div>
          </div>
        </div>
        <div v-else-if="item.category === 3" class="tile is-child">
          <div :class="item.readStatus ? '' : 'bold-text'" class="name_shop tile">
            <div class="tile">{{ title }}</div>
          </div>
          <div :class="item.readStatus ? '' : 'bold-text'" class="content mt-10" v-html="contentDetail"></div>
        </div>
        <div v-else class="tile is-child">
          <div :class="item.readStatus ? '' : 'bold-text'" class="name_shop tile">
            <div class="tile">{{ title }}</div>
          </div>
          <div :class="item.readStatus ? '' : 'bold-text'" class="content mt-10" v-html="contentDetail"></div>
        </div>
      </div>
      <div class="tile is-parent is-2 notification-time">
        <div class="tile is-child">{{ time }}</div>
      </div>
    </div>
  </router-link>
</template>
<style lang="scss" src="./item-notication.scss" scoped>
</style>

<script>
import RatingIcon from '@/components/common/rating-icon.vue';
export default {
  name: 'NotificationItem',
  components: {
    RatingIcon
  },
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {};
  },
  computed: {
    title: function() {
      return this.item && this.item.title ? this.$t(this.item.title) : '';
    },
    image: function() {
      return this.item && this.item.image ? this.item.image : require('@/assets/images/logo/primary.svg');
    },
    time: function() {
      const createdAt = this.item.createdAt.seconds || this.item.createdAt._seconds;
      return this.$moment(new Date(createdAt * 1000)).fromNow();
    },
    content: function() {
      if (!this.item || !this.item.content)
        return {
          productId: null,
          productName: '',
          title: '',
          comment: '',
          rating: null,
          detail: ''
        };

      return JSON.parse(this.item.content);
    },
    contentDetail: function() {
      return this.content && this.content.detail ? this.$t(this.content.detail) : '';
    }
  }
};
</script>
